import React, { memo, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
import '../../PitchClock.scss';

const colors = new Colors();

const SIZE = 100;

const PitchClock = ({sequencerEngine, trackStep=0, size=100}) => { 
    let notesTriggered = new Set();
    let noteToTracks = {};
    for (let sub of sequencerEngine.subSequences) {
        for (let track of sub.tracks) {
            let _notesTriggered = track.notesTriggered || {};
            for (let note in _notesTriggered) {
                note = mod(note, 12);
                notesTriggered.add(note);
                if (!noteToTracks[note]) {
                    noteToTracks[note] = [];
                }
                noteToTracks[note].push(track);
            }
        }
    }
    let notes = [0,1,2,3,4,5,6,7,8,9,10,11];
    trackStep = trackStep  % 32;
    let roundCircum = 2 *size * Math.PI;
    let roundDraw = (trackStep / 32.0) * roundCircum;
    return (
        <div className="pitch-clock">
          <svg>
            <circle
              strokeDasharray={[roundDraw, 999]}
              cx={size} cy={size} r={size} stroke="white"/>
            <g className="marks">
              {notes.map(note => <PitchBar size={size} tracks={noteToTracks[note]} key={note} note={note} isPlayed={notesTriggered.has(note)}/>)}
            </g>
          </svg>
        </div>
    );
};

const PitchBar = memo(({note, isPlayed, tracks, size}) => {
    let lines = [];
    let line = (
        <line
          x1={0}
          y1={0}
          x2={size}
          y2={0}
          className={isPlayed ? "played mark" : "mark"}/>);
    
    if (tracks) {
        let part = (1.0 * size) / tracks.length;
        for (let i=0; i < tracks.length; i++) {
            let track = tracks[i];
            lines.push(
                <circle
                  cx={(i)*part}
                  cy={-20}
                  r={3}
                  stroke={colors.getColorForTrack(track)}/>);;
        }
    }
    
    return <g>{line} {lines}</g>;
});


const mapStateToProps = (state, props) => {
  return {
      trackStep: props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mod = (x,n) => {
    return ((x%n)+n)%n;
};

export default connect(mapStateToProps, mapDispatchToProps)(PitchClock);
